import {LOAD_PDF_FILE} from './actions';
//import {fs2} from "fs2";

//var fs = require('fs');
var FileSaver = require('file-saver');

const initialState = {
  pdfFile:null

};


export default function reducer(state = initialState, action) {
  switch (action.type) {
      case LOAD_PDF_FILE:
           var len = action.pdfFile.length;
           console.log("The pdf file length is " + len);
          var bytes = new Array( len );
          //var bytes = new Array( len );
          for (var i = 0; i < len; i++){

              //if(i <len-1) {
                  bytes[i] = action.pdfFile.charCodeAt(i);

                  /*if(i<20) {
                      console.log("The pdf  byte is " + action.pdfFile[i] + "  Byte is " + bytes[i]);
                  }*/


              //}
          }
        /*
          var bytes2 = new Uint8Array( len );
          for (var j = 0; j < len; j++){
             // if(i <len-1) {
                  bytes2[j] = action.pdfFile.charAt(j);
              if(j<20) {
                  console.log(" second one The pdf  byte is " + action.pdfFile[j] + " Byte is " + bytes2[j]);
              }

              // }
          }
            */
          //var file = new Blob(bytes, {type: "application/pdf"});
          //var file = new Blob(action.pdfFile, {type: ""});
          //var file = new Blob(bytes2, {type: "application/pdf"});
         // var file = new Blob(bytes,{type: "application/pdf"});
          //"application/octet-stream"
          var file = null;
          if(action.pdfFile.length != 0) {
              file = new Blob([action.pdfFile],{type: "application/pdf"} );

              //FileSaver.saveAs(file, "myfarshid.pdf");
          }
          /*var fs = require('fs');
          fs.writeFile("tempfarshid.pdf", action.pdfFile, (err)=> {
              // throws an error, you could also catch it here
              if (err) throw err;

              // success case, the file was saved
              console.log('Lyric saved!');
          });*/

          return  {
              pdfFile: file }
          /*return Object.assign({}, state, {
              pdfFile:action.pdfFile
          });*/


    default:
      return state;
  }
}
